import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface BulletinCategory {
  id: string;
  name: string;
  post_count: number;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export function useBulletinCategories() {
  return useQuery({
    queryKey: ["bulletin-categories"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("bulletin_categories")
        .select("*")
        .eq("is_active", true)
        .order("post_count", { ascending: false });

      if (error) {
        console.error("Error fetching bulletin categories:", error);
        throw error;
      }

      return data as BulletinCategory[];
    },
    refetchInterval: 30000, // Refetch every 30 seconds to keep categories updated
  });
}